import { render, staticRenderFns } from "./WorldDetails.vue?vue&type=template&id=31f24cdc&scoped=true"
import script from "./WorldDetails.vue?vue&type=script&lang=js"
export * from "./WorldDetails.vue?vue&type=script&lang=js"
import style0 from "./WorldDetails.vue?vue&type=style&index=0&id=31f24cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f24cdc",
  null
  
)

export default component.exports